export default __webpack_public_path__ + "static/media/cpu.1a692a59.svg";